import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverRankingListedAdminDto } from '@/backend/market'
import { DriverRankingEntity } from '../../domain/entities/DriverRankingEntity'

export class DriverRankingModel extends DriverRankingEntity {
  constructor(data: DriverRankingListedAdminDto) {
    super()
    mapEntityProperties(this, data)
  }
}
